import targetTypes from '../constants/target-types';
import getTargetType from './get-target-type';
import getAttributeActionsToApply from './get-attribute-actions-to-apply';
import getClassActionsToApply from './get-class-actions-to-apply';

const splitStateByTargetType = (state = {}) => {
  const attributeState = {};
  const classState = {};

  Object.keys(state).forEach((elementId) => {
    Object.keys(state[elementId]).forEach((key) => {
      const value = state[elementId][key];
      const targetType = getTargetType(key);
      const targetState = targetType === targetTypes.CLASS ? classState : attributeState;

      if (!targetState[elementId]) {
        targetState[elementId] = {};
      }

      targetState[elementId][key] = value;
    });
  });

  return { attributeState, classState };
};

const getTargetActionsToApply = (state = {}, options = {}) => {
  if (!Object.keys(state).length) {
    return [];
  }

  const { attributeState, classState } = splitStateByTargetType(state);
  const attributeActions = getAttributeActionsToApply(attributeState, options);
  const classActions = getClassActionsToApply(classState, options);

  return [...attributeActions, ...classActions];
};

export default getTargetActionsToApply;
